import BaseForm from "@common-components/form/components/BaseForm";
import RootStore from "@stores/RootStore";

export default class UserAddressForm extends BaseForm {
    constructor(hooks: any, fields: any, rootStore: RootStore) {
        super(hooks, fields, rootStore)
    }

    setup() {
        return {
            fields: [
                {
                    name: 'id',
                    rules: 'string',
                    output: (value: string) => value === '' ? null : value
                },
                {
                    name: 'address',
                    label: 'Adresa',
                    placeholder: 'Unesi adresu',
                    rules: 'required|string',
                },
                {
                    name: 'locationDescription',
                    label: 'Opis lokacije',
                    placeholder: 'Unesi opis lokacije',
                    rules: 'string',
                    output: (value: string) => value === '' ? null : value
                }
            ],
        };
    }
}